// Packages
import { atom } from 'recoil'

export const bookACallFormModalIsVisible = atom<boolean>({
  key: 'bookACallFormModal',
  default: false
})
